var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmojiArc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3.5C7.30558 3.5 3.5 7.30558 3.5 12C3.5 16.6944 7.30558 20.5 12 20.5C16.6944 20.5 20.5 16.6944 20.5 12C20.5 7.30558 16.6944 3.5 12 3.5ZM2 12C2 6.47716 6.47716 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12ZM9.75 7C10.1642 7 10.5 7.33579 10.5 7.75V11.25C10.5 11.6642 10.1642 12 9.75 12C9.33579 12 9 11.6642 9 11.25V7.75C9 7.33579 9.33579 7 9.75 7ZM14.25 7C14.6642 7 15 7.33579 15 7.75V11.25C15 11.6642 14.6642 12 14.25 12C13.8358 12 13.5 11.6642 13.5 11.25V7.75C13.5 7.33579 13.8358 7 14.25 7ZM8.10688 14.8641C8.31999 14.5089 8.78069 14.3938 9.13587 14.6069C10.1756 15.2307 11.1058 15.5125 12 15.5125C12.8942 15.5125 13.8244 15.2307 14.8641 14.6069C15.2193 14.3938 15.68 14.5089 15.8931 14.8641C16.1062 15.2193 15.9911 15.68 15.6359 15.8931C14.4256 16.6193 13.2308 17.0125 12 17.0125C10.7692 17.0125 9.57441 16.6193 8.36413 15.8931C8.00894 15.68 7.89377 15.2193 8.10688 14.8641Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmojiArc);
export default __webpack_public_path__ + "static/media/emoji-arc.3a203086daa32640a59dc596d7baf7a1.svg";
export { ForwardRef as ReactComponent };